import { AiOutlineSchedule } from "react-icons/ai";
import {
  FaArrowsLeftRightToLine,
  FaArrowsRotate,
  FaBarsProgress,
  FaBook,
  FaBox,
  FaBriefcaseMedical,
  FaBuildingFlag,
  FaBusinessTime,
  FaCalendarDay,
  FaCalendarDays,
  FaChartArea,
  FaChartLine,
  FaChartSimple,
  FaChromecast,
  FaClipboardList,
  FaCubes,
  FaCubesStacked,
  FaDatabase,
  FaDna,
  FaEarthAmericas,
  FaEnvelopesBulk,
  FaFont,
  FaGears,
  FaHandHoldingMedical,
  FaHandshake,
  FaHospital,
  FaHouse,
  FaLayerGroup,
  FaLink,
  FaListCheck,
  FaListUl,
  FaLocationDot,
  FaNfcDirectional,
  FaPalette,
  FaPeopleRoof,
  FaPlantWilt,
  FaReadme,
  FaRegChartBar,
  FaRegCircleQuestion,
  FaScaleUnbalanced,
  FaScaleUnbalancedFlip,
  FaScrewdriverWrench,
  FaSitemap,
  FaSliders,
  FaSquareCaretDown,
  FaStethoscope,
  FaStumbleupon,
  FaSuitcaseRolling,
  FaBuilding,
  FaTeamspeak,
  FaTriangleExclamation,
  FaUmbrellaBeach,
  FaUser,
  FaUserGear,
  FaUserLock,
  FaUsersViewfinder,
  FaWarehouse,
} from "react-icons/fa6";
import * as routes from "./routes";
import { ROLES } from "./roleConstants";

export const SIDE_BAR_MENUS = [
  {
    title: "Home",
    icon: <FaHouse />,
    link: routes.BASE_PATH_PREFIX,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.PROVIDER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },
  {
    title: "Tenant Management",
    icon: <FaBuilding />,
    link: routes.TENANT_MANAGEMENT,
    roles: [ROLES.SUPER_ADMIN],
  },
  // {
  //   title: "TimeZone",
  //   icon: <FaListCheck />,
  //   link: routes.MASTER_TIMEZONE_MANAGEMENT,
  //   roles: [ROLES.SUPER_ADMIN],
  // },
  {
    title: "User Management",
    icon: <FaUserGear />,
    link: routes?.USERMANAGEMENT,
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    title: "Live Available Shifts",
    icon: <FaScaleUnbalanced />,
    link: routes.LIVE_AVAILABLE_SHIFTS,
    roles: [ROLES.PROVIDER, ROLES.STAKE_HOLDERS],
  },
  {
    title: "Providers",
    icon: <FaBriefcaseMedical />,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
    subMenus: [
      {
        title: "Provider List",
        icon: <FaUser />,
        link: routes.RAD_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Unassigned Providers",
        icon: <FaUser />,
        link: routes.UNASSIGNED_PROVIDER_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      // {
      //   title: "Capacity Input",
      //   icon: <FaBox />,
      //   link: routes.CAPACITY_INPUT,
      //   roles: [
      //     ROLES.ADMIN,
      //     ROLES.OPS_TEAM,
      //     ROLES.SHEDULER,
      //     ROLES.STAKE_HOLDERS,
      //     ROLES.TENANT_ADMIN,
      //   ],
      // },
      {
        title: "Capacity",
        icon: <FaBox />,
        link: routes.CAPACITY_INPUT_NEW,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      // { title: "Custom View", icon: <FaUsersViewfinder />, link: "/Explorer", roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      {
        title: "Custom View",
        icon: <FaUsersViewfinder />,
        link: routes.CUSTOM_VIEW,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Leadership Bulk Update",
        icon: <FaEnvelopesBulk />,
        link: routes.RAD_LEADERSHIP_BULK_UPDATE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Hourly Volume Share",
        icon: <FaCalendarDays />,
        link: routes.RAD_HOURLY_VOLUME_SHARE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Annual Hour Tracker",
        icon: <FaBuildingFlag />,
        link: routes.ANNUAL_HOUR_TRACKER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Audit Logs",
        icon: <FaStumbleupon />,
        link: routes.AUDIT_LOGS,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "State License",
        icon: <FaClipboardList />,
        link: routes.STATE_LICENSE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "License & Privileges Power Sync",
        icon: <FaArrowsRotate />,
        link: routes.LICENSE_PRIVILEGE_POWER_SYNC,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },
  // Provider Login
  {
    title: "Profile",
    icon: <FaUser />,
    link: routes.RAD_PROFILE,
    roles: [ROLES.PROVIDER],
  },
  {
    title: "Facilities",
    icon: <FaSitemap />,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
    subMenus: [
      {
        title: "Facility List",
        icon: <FaListUl />,
        link: routes.SITE_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Unassigned Facilities",
        icon: <FaTriangleExclamation />,
        link: routes.UNASSIGNED_SITES,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Alias Management",
        icon: <FaFont />,
        link: routes.SITEALIASMANAGEMENT_SITE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Hourly Volume Share",
        icon: <FaBuildingFlag />,
        link: routes.SITE_HOURLY_VOLUME_SHARE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },
  {
    title: "Admin",
    icon: <FaUserLock />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      // { title: "Main Practice", icon: <FaLocationDot />, link: routes?.MAIN_PRACTICE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // { title: "Regional Practice Worklist", icon: <FaMapPin />, link: routes?.REGIONALPRACTICEWORKLIST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      {
        title: "National",
        icon: <FaEarthAmericas />,
        link: routes?.NATIONAL,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Region",
        icon: <FaLocationDot />,
        link: routes?.REGION,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      // { title: "Regional Practice", icon: <FaLocationDot />, link: routes?.REGIONALPRACTICE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // {
      //   title: "RPCE",
      //   icon: <FaPlantWilt />,
      //   link: routes?.RPCE,
      //   roles: [
      //     ROLES.ADMIN,
      //     ROLES.OPS_TEAM,
      //     ROLES.SHEDULER,
      //     ROLES.TENANT_ADMIN,
      //   ],
      // },
      // {
      //   title: "Worklist",
      //   icon: <FaClipboardList />,
      //   link: routes?.WORKLIST,
      //   roles: [
      //     ROLES.ADMIN,
      //     ROLES.OPS_TEAM,
      //     ROLES.SHEDULER,
      //     ROLES.TENANT_ADMIN,
      //   ],
      // },
      {
        title: "Practice",
        icon: <FaHospital />,
        link: routes?.PRACTICE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Sub Practice",
        icon: <FaStethoscope />,
        link: routes?.SUBPRACTICE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Worklist Definition",
        icon: <FaGears />,
        link: routes?.WORKLIST_DEFINITION,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Worklist Group",
        icon: <FaLayerGroup />,
        link: routes?.WORKLIST_GROUP,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Tag Management",
        icon: <FaFont />,
        link: routes?.TAG_CATEGORY_CONFIGURATION,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Section Worklist Mapping",
        icon: <FaListCheck />,
        link: routes?.SECTIONWORKLIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Holiday Planner",
        icon: <FaUmbrellaBeach />,
        link: routes?.HOLIDAYPLANNER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "User Management",
        icon: <FaUserGear />,
        link: routes?.USERMANAGEMENT,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "Configuration",
        icon: <FaScrewdriverWrench />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Facility Coverage Matrix",
            icon: <FaSitemap />,
            link: routes?.SITECOVERAGEMATRIX,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Priority Mapping",
            icon: <FaHandshake />,
            link: routes?.PRIORITYSLAMAPPING,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "DLS",
            icon: <FaBusinessTime />,
            link: routes?.DLS_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Task Configuration",
            icon: <FaSliders />,
            link: routes.TASK_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Coverage Gap Color Configuration",
            icon: <FaBarsProgress />,
            link: routes?.COVERAGE_GAP,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Simulator Color Configuration",
            icon: <FaPalette />,
            link: routes?.SIMULATOR_COLOR_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Day of Week Configuration",
            icon: <FaCalendarDay />,
            link: routes?.DAY_OF_WEEK_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Shift Hour Configuration",
            icon: <FaPeopleRoof />,
            link: routes?.SHIFT_HOUR_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Block Planning Color Configuration",
            icon: <FaPalette />,
            link: routes?.BLOCK_PLANNING,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "License & Privilege Status Mapping",
            icon: <FaLink />,
            link: routes?.LICENSE_PRIVILEGE_STATUS_MAPPING,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
        ],
      },
      {
        title: "Dropdown Management",
        icon: <FaSquareCaretDown />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Provider Type",
            icon: <FaListCheck />,
            link: routes.RAD_TYPE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Provider Status",
            icon: <FaListCheck />,
            link: routes.RAD_STATUS,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Provider Title",
            icon: <FaListCheck />,
            link: routes?.RAD_DEGREE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Provider Communication Type",
            icon: <FaListCheck />,
            link: routes?.RAD_COMMUNICATION_TYPE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Subspecialty",
            icon: <FaListCheck />,
            link: routes?.SUBSPECIALITY,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Week Rotation",
            icon: <FaListCheck />,
            link: routes?.WEEK_ROTATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Schedule Type",
            icon: <FaListCheck />,
            link: routes.SCHEDULETYPE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "RVU Rate",
            icon: <FaListCheck />,
            link: routes?.RVURATE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Partnership Rate",
            icon: <FaListCheck />,
            link: routes?.PARTNERSHIP_RATE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Partnership Status",
            icon: <FaListCheck />,
            link: routes?.PARTNERSHIP_STATUS,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Time to Partnership",
            icon: <FaListCheck />,
            link: routes?.PARTNERSHIP_TIME,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Request Status",
            icon: <FaListCheck />,
            link: routes?.REQUEST_STATUS,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Committees",
            icon: <FaListCheck />,
            link: routes?.COMMITTEES,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Future Section Change",
            icon: <FaListCheck />,
            link: routes?.FUTURE_SECTION_CHANGE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Trauma Facility Level",
            icon: <FaListCheck />,
            link: routes?.TRAUMA_FACILITY_LEVEL,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Facility Status",
            icon: <FaListCheck />,
            link: routes?.SITE_STATUS,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // {
          //   title: "Encore Section",
          //   icon: <FaListCheck />,
          //   link: routes?.QGENDA_SECTION,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
          {
            title: "Time Zone",
            icon: <FaListCheck />,
            link: routes?.TIMEZONE_MANAGEMENT,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Week Rotation Template",
            icon: <FaListCheck />,
            link: routes?.WEEK_ROTATION_TEMPLATE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Modality",
            icon: <FaListCheck />,
            link: routes?.MODALITY,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // {
          //   title: "Priority",
          //   icon: <FaListCheck />,
          //   link: routes?.PRIORITY,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
          {
            title: "Provider Category",
            icon: <FaListCheck />,
            link: routes?.STAFF_CATEGORY,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Staff Primary Location",
            icon: <FaListCheck />,
            link: routes?.STAFF_PRIMARY_LOCATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Specialty Cases",
            icon: <FaListCheck />,
            link: routes?.SPECIALTY_CASES,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Staffing Agency",
            icon: <FaListCheck />,
            link: routes?.STAFFING_AGENCY,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Document Category",
            icon: <FaListCheck />,
            link: routes.PROVIDER_DOCUMENT_TYPE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Note Category",
            icon: <FaListCheck />,
            link: routes.PROVIDER_NOTE_TYPE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Exam",
    icon: <FaTeamspeak />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      {
        title: "Raw Exam Data",
        icon: <FaDna />,
        link: routes.RAW_EXAM_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Exam Data",
        icon: <FaWarehouse />,
        link: routes.EXAM_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Exam Metrics",
        icon: <FaNfcDirectional />,
        link: routes.EXAM_METRICS,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Misc. Facility Data",
        icon: <FaPeopleRoof />,
        link: routes.MISCELLANEOUS_SITE_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      // { title: "Read", icon: <FaReadme />, link: routes.EXAM_DATA_READ, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // { title: "Unread", icon: <FaBook />, link: routes.UNREAD, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // { title: "TAT", icon: <FaNfcDirectional />, link: routes.TAT_DATA, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] }
    ],
  },
  // {
  //   title: "Reports",
  //   icon: <FaChartLine />,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.STAKE_HOLDERS],
  //   subMenus: [
  //     {
  //       title: "Encore Daily Report",
  //       icon: <FaChartSimple />,
  //       link: routes.MATRIX_DAILY_REPORT,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Performance Dashboard",
  //       icon: <FaChartArea />,
  //       link: routes.PERFORMANCE_DASHBOARD,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Coverage Gap Tool",
  //       icon: <FaArrowsLeftRightToLine />,
  //       link: routes.COVERAGE_GAP_TOOL,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Holiday Gap Tool",
  //       icon: <FaSuitcaseRolling />,
  //       link: routes.HOLIDAY_GAP_TOOL,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     {
  //       title: "Privilege Power Sync",
  //       icon: <FaArrowsRotate />,
  //       link: routes.PRIVILEGE_POWER_SYNC,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     {
  //       title: "Report Configuration",
  //       icon: <FaGears />,
  //       link: routes.REPORT_CONFIGURATION,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     // { title: "Report Configuration", icon: <FaGears />, link: routes.REPORT_CONFIGURATION, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] }
  //   ],
  // },
  // {
  //   title: "Strategic Forecast",
  //   icon: <FaCubesStacked />,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  //   subMenus: [
  //     {
  //       title: "Encore Service Request",
  //       icon: <FaHandHoldingMedical />,
  //       link: routes.MATRIX_SERVICE_REQUEST,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //     {
  //       title: "Strategic Demand Planner",
  //       icon: <FaTriangleExclamation />,
  //       link: routes.STRATEGIC_DEMAND_PLANNER,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //     {
  //       title: "Strategic Capacity Planner",
  //       icon: <FaCubes />,
  //       link: routes.STRATEGIC_CAPACITY_PLANNER,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //     {
  //       title: "Strategic Capacity vs Demand Planner",
  //       icon: <FaScaleUnbalancedFlip />,
  //       link: routes.STRATEGIC_CAPS_VS_DEMAND_PLANNER,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //   ],
  // },
  // // { title: "Schedule", icon: <AiOutlineSchedule />, link: routes.SCHEDULE_PATH, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  // {
  //   title: "Volume Trend Report",
  //   icon: <FaCalendarDays />,
  //   link: routes.VOLUME_TREND_REPORT,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  // },
  // {
  //   title: "Demand Table",
  //   icon: <FaChromecast />,
  //   link: routes.DEMAND_TABLE,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  // },
  // {
  //   title: "Capacity Table",
  //   icon: <FaDatabase />,
  //   link: routes.CAPACITY_TABLE,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  // },
  // {
  //   title: "Capacity Vs Demand",
  //   icon: <FaScaleUnbalanced />,
  //   link: routes.CAPS_VS_DEMAND_TABLE,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  // },

  // {
  //     title: "Demand Forecasting",
  //     icon: <FaCubesStacked />,
  //     roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     subMenus: [
  //         { title: "Forecasting", icon: <FaRegChartBar />, link: routes.FORECAST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Optimize", icon: <FaRegChartBar />, link: routes.FORECAST_OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Caps Vs Demand", icon: <FaRegChartBar />, link: routes.FORECAST_CAPSVSDEMAND, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Report", icon: <FaRegChartBar />, link: routes.FORECASTREPORT, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },

  //     ]
  // },

  // {
  //     title: "Predictive Analytics",
  //     icon: <FaCubesStacked />,
  //     roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     subMenus: [
  //         { title: "Forecast", icon: <FaRegChartBar />, link: routes.FORECASTING_FORECAST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Optimize", icon: <FaRegChartBar />, link: routes.FORECASTING_OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Schedules", icon: <FaRegChartBar />, link:routes.FORECASTING_SCHEDULES, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //     ]
  // },

  // { title: "Optimize", icon: <FaGears />, link: routes.OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },

  // {
  //   title: "Scheduling",
  //   icon: <AiOutlineSchedule />,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //   subMenus: [
  //     {
  //       title: "Schedule",
  //       icon: <FaCalendarDays />,
  //       link: routes.SCHEDULE_PATH,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     {
  //       title: "Manage Links",
  //       icon: <FaLink />,
  //       link: routes.SCHEDULE_SHARE_LINKS,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //   ],
  // },

  // {
  //   title: "User Manual",
  //   icon: <FaRegCircleQuestion />,
  //   link: "/Explorer",
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  // },
];
